'use client'

import { Badge, Box, Flex, useMediaQuery } from '@chakra-ui/react'
import Image from 'next/image'
import { useContext, useMemo } from 'react'

import LayoutContext from '@/context/LayoutCtx'
import getLogoSizes from '@/theme/Logo/sizes'
import { TenantsType } from '@/consts/setupApp/tenants'
import { mappTenant } from '@/consts/tenants/front'
import { getEnvironment } from '@/utils/getEnvironment'
import { useAppSetupStore } from '@/context/appSetup'

export default function Logo({ type }: { type: 'dashboardLogo' | 'detailLogo' }) {
  const { isNavOpen: isOpen } = useContext(LayoutContext)
  const [isLargerThan900] = useMediaQuery('(min-width: 900px)')
  const tenant = useAppSetupStore((state) => state.tenant)
  const tenantMapped = mappTenant[tenant] || tenant
  const sizes = useMemo(() => getLogoSizes(tenantMapped), [tenantMapped])
  const key = isLargerThan900 ? 'desktop' : 'mobile'
  const { isDevelopment, isStaging, environment, isUat } = getEnvironment(tenant as TenantsType)
  const height = sizes[type][key].height || 25
  const width = sizes[type][key].width || 100

  return (
    <Box display={{ base: 'block', lg: isOpen ? 'block' : 'none' }}>
      <Flex alignItems={'center'} gap={2} height={height > 40 ? 40 : height}>
        <Image
          alt={`${tenantMapped} logo`}
          height={height > 40 ? 40 : height}
          src={`/images/${tenantMapped}/logo.svg`}
          style={{
            maxWidth: '175px',
            height: 'auto',
            maxHeight: 40
          }}
          width={width}
        />
        {isDevelopment && (
          <Badge colorScheme={'blue'} fontSize={10}>
            {environment}
          </Badge>
        )}
        {isStaging && (
          <Badge colorScheme={'green'} fontSize={10}>
            {environment}
          </Badge>
        )}
        {isUat && (
          <Badge colorScheme={'cyan'} fontSize={10}>
            {environment}
          </Badge>
        )}
      </Flex>
    </Box>
  )
}
